module.exports = __webpack_public_path__ + "img/smartbet.c4b2351c.svg";